import { forwardRef, type Ref, type SVGProps } from "react";

function SvgOldPhone(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.16669 1.16675C3.44283 1.16675 3.66669 1.39061 3.66669 1.66675V2.69998C3.91671 2.57217 4.19995 2.50008 4.50002 2.50008H11.5C12.5125 2.50008 13.3334 3.32089 13.3334 4.33341V12.0001C13.3334 13.749 11.9156 15.1667 10.1667 15.1667H5.83335C4.08445 15.1667 2.66669 13.749 2.66669 12.0001V1.66675C2.66669 1.39061 2.89054 1.16675 3.16669 1.16675ZM5.83335 5.16675C5.55721 5.16675 5.33335 5.39061 5.33335 5.66675V9.33342C5.33335 9.60956 5.55721 9.83342 5.83335 9.83342H10.1667C10.4428 9.83342 10.6667 9.60956 10.6667 9.33342V5.66675C10.6667 5.39061 10.4428 5.16675 10.1667 5.16675H5.83335Z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgOldPhone);
export default ForwardRef;
